import { Flex, Text } from '@chakra-ui/react';
import { ServiceLandingPost } from '../../types';
import { resolveFields } from '../Fields';
import TeaserHeroFull from '../TeaserHeroFull';
import ArticleContainer from '../ArticleContainer';
import SelectedServices from '../Services/SelectedServices';
import Heading from '../Heading';
import { BlockRenderer } from '../Fields/BlockRenderer';

const ServiceLanding = ({
  data: {
    sub_services: services = [],
    service_categories: categories = [],
  } = {},
  post_title: title,
  post_excerpt: leadText,
  fields,
}: ServiceLandingPost) => {
  const [hero, contentFields] = resolveFields(fields);

  return (
    <ArticleContainer>
      {hero && <TeaserHeroFull {...hero} />}
      <Flex alignItems="top" flexWrap={['wrap', 'wrap', 'nowrap']} py={12}>
        <Heading
          as="h1"
          sx={{ ':not(:only-child)': { mb: 5 } }}
          flex={['0 0 100%', '0 0 100%', '0 0 33.3333%']}
        >
          {title}
        </Heading>
        {leadText && <Text textStyle="xl">{leadText}</Text>}
      </Flex>
      <SelectedServices services={services} categories={categories} />
      <BlockRenderer blocks={contentFields} />
    </ArticleContainer>
  );
};

export default ServiceLanding;
